import {
  getEnv,
  handleNetwork,
  ky,
  memoize,
  returnNetworkError,
  ValidationError,
} from "@solvari/utils";

const getPhoneValidation = handleNetwork(
  memoize(async (phone: string) => {
    const result = await returnNetworkError(() =>
      ky
        .get(`${getEnv().network.api}/v3/validations/phone`, {
          searchParams: { phone },
        })
        .json<undefined>(),
    )();
    if (!result) {
      return true;
    }
    if (result instanceof ValidationError) {
      return false;
    }
    return result;
  }),
);

export { getPhoneValidation };
